import { NgFor, NgIf } from '@angular/common';
import { Component, HostBinding } from '@angular/core';

import { DeviceService } from '@frontend/vanilla/core';

@Component({
    selector: 'ms-skeleton-betslip',
    templateUrl: './skeleton-betslip.component.html',
    imports: [NgIf, NgFor],
})
export class SkeletonBetslipComponent {
    @HostBinding('class') className = 'sk-betslip-container sk-b-rad5 sk-p-12';

    constructor(public device: DeviceService) {}
}
